import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import DottedLoading from "../DottedLoading/DottedLoading";

function CourseRejectModal({ show, onClose, onSubmit, courseId }) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!reason.trim()) {
      setError("Please provide a reason for rejection.");
      return;
    }
    setError("");
    setIsSubmitting(true);
    try {
      await onSubmit(courseId, reason);
      setReason("");
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Reject Course</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="rejectReason">
            <Form.Label className="black-100 fw-semibold mb-8 mb-lg-12">Reason for Rejection</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.trim()) {
                  setError("");
                }
              }}
              placeholder="Please provide the reason for rejecting this course..."
              required
            />
            {error && (
              <Form.Control.Feedback
                type="invalid"
                style={{ display: "block" }}
              >
                {error}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? <DottedLoading /> : "Submit Rejection"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CourseRejectModal;
